// @flow
import React from 'react';

import { createLocalisationUpdateOeuvre, updateLocalisationUpdateOeuvre } from 'Api';
import LocalisationForm from 'pages/Avila/Localisation/Form'
import { useTranslation } from 'react-i18next'

import FormModal from './FormModal'

type Props = {
    oeuvreid: string,
    onClose: any => any,
    actions: Array<any>,
    data: any,
    onSave: any => any
}
export default ({
    onClose,
    actions = [],
    data,
    oeuvre,
    oeuvreid,
    isMultiple,
    onSave = () => {}
}: Props) => {

    const { t } = useTranslation();

    return (

        <FormModal
            title={t("localisation")}
            data={data}
            onClose={onClose}
            FormComponent={({ data, onChange }) => (
                <LocalisationForm
                    isMultiple={isMultiple}
                    data={data}
                    onChange={onChange}
                />
            )}

            onSave={onSave}
            updateMethod={({ data }) => updateLocalisationUpdateOeuvre({ oeuvreid, data, oeuvre })}
            createMethod={({ data }) => createLocalisationUpdateOeuvre({ oeuvre, data })}
        />
    )
}